// React Imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// Redux Imports
import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";

// Component Imports
import CardContainer from "../../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import Loader from "../../../../components/Loader/Index";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker";

//Utils Imports
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { custom_category_base_url } from "../../../../utils/categoryIconMapper";

const CustomCategoryViewAll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [active, setActive] = useState("");

  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams({});

  const [searchString, setSearchString] = useState(
    searchParam.get("search") || "",
  );

  const [sortValue, setSortValue] = useState(searchParam.get("sort") || "");

  const [typeValue, setTypeValue] = useState(searchParam.get("type") || "");

  const [statusValue, setStatusValue] = useState(
    searchParam.get("status") || "",
  );

  const [categoryData, setCategoryData] = useState([]);
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  const [ensureAll] = useServiceChecker();
  const hasCTransactionCategory = ensureAll(["CTransactionCategory"]);

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleClearParams = (e) => {
    handleClearSearchParam();

    if (showInnerSearchBar) return;
    setSearchString("");
    setSearchText("");
    setSortValue("");
    setStatusValue("");
    setTypeValue("");
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLocalLoading(true);
      try {
        const response = await dispatch(
          beneCategories({
            search_string: searchString,
            sort_by:
              sortValue === "Alphabetical : A to Z"
                ? "ascending"
                : sortValue === "Alphabetical : Z to A"
                  ? "descending"
                  : sortValue === "Order : Latest"
                    ? "latest"
                    : sortValue === "Order : Oldest"
                      ? "oldest"
                      : "ascending",
            category_status: statusValue,
            category_type: typeValue,
          }),
        );
        setCategoryData(response?.payload?.categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategoryData([]);
      } finally {
        setIsLocalLoading(false);
      }
    };

    fetchData();
  }, [searchString, sortValue, statusValue, typeValue, dispatch]);

  return false ? (
    <>
      <div className="fixed top-top-base left-left-base w-screen h-screen flex flex-col items-center justify-center z-z-index-loader">
        <div className="h-navbar-breadcrumb-height Qmd:block hidden"></div>
        <div>
          <Loader type={"bulk_upload"} />
        </div>
      </div>
    </>
  ) : (
    <div className="h-full-height flex flex-col overflow-y-hidden">
      {showInnerSearchBar && (
        <div className="h-full-height w-full-width fixed bg-PopUp-BackDrop opacity-dark-opacity z-z-index-overlay"></div>
      )}
      <>
        <div className="relative z-z-index-overlay">
          <div className="h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav"></div>
          <TopNavComponent
            topNavCtaBtnWithIcon1Props={{
              btnText: "Add category",
              btnType: "button",
              handleFunction: () => {
                if (hasCTransactionCategory.status) {
                  navigate("/settings/category_dashboard/add_category");
                } else {
                  navigate("/feature_not_assigned", {
                    state: hasCTransactionCategory.unavailableService,
                  });
                }
              },
              isDisabled: !hasCTransactionCategory.status || isLocalLoading,
              enabledTextColor: "var(--primary-bg)",
              disabledTextColor: null,
              enabledBgColor: "var(--text-primary)",
              disabledBgColor: null,
              isLoading: false,
              outLineColor: null,
              hoverOption: "black",
              buttonRef: null,
              fullWidthRequired: null,
              inActiveVariantNeeded: null,
              isLoaderNeeded: null,
              icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
              imgColor: "var(--primary-bg)",
              iconToBeAlign: "right",
            }}
            filteredSearchProps={{
              onSearchInput: (e) => setSearchText(e),
              searchInputRef: null,
              searchText: searchText,
              searchPlaceholder: "Search in Category",
              filterPlaceholder: "Category name / description",
              isSearchDisabled: isLocalLoading,
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchString,
                  setValue: (val) => {
                    handleSubmit("search", val);
                    setSearchString(val);
                  },
                  isDropdown: false,
                  isDisabled: isLocalLoading,
                },
              ],
              filters: [
                {
                  name: "Category status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: statusValue,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: isLocalLoading,
                  options: ["active", "inactive"],
                  statusPop: true,
                  handleChange: (val) => {
                    handleSubmit("status", val);
                    setStatusValue(val);
                  },
                },

                {
                  name: "Category type",
                  filterType: "dropdown",
                  variant: "single",
                  dropdownPlaceHolder: "Select type",
                  isDisabled: isLocalLoading,
                  size: "small",
                  value: typeValue,
                  options: ["custom", "default"],
                  handleChange: (val) => {
                    handleSubmit("type", val);
                    setTypeValue(val);
                  },
                },
              ],
              loading: isLocalLoading,
              inputData: [],
              setShowInnerSearchBar: setShowInnerSearchBar,
              setActive: setActive,
              isShowSortBy: true,
              isShowFilter: true,
              showSearchBar: false,
              isFilterClearAllDisabled: !(statusValue || typeValue),
              isSearchClearAllDisabled: null,
              sortByFilter: [
                {
                  name: "Alphabetical : A to Z",
                  default: true,
                },
                {
                  name: "Alphabetical : Z to A",
                },
                {
                  name: "Order : Latest",
                },
                {
                  name: "Order : Oldest",
                },
              ],
              active: active,
              sortValue: sortValue,
              sortHandleChange: (val) => {
                handleSubmit("sort", val);
                setSortValue(val);
              },
              isSortDisabled: isLocalLoading,
              isFilterDisabled: isLocalLoading,
            }}
          />
        </div>
        {isLocalLoading ? (
          <>
            <div className="fixed top-top-base left-left-base w-screen h-screen flex flex-col items-center justify-center z-z-index-loader">
              <div className="h-navbar-breadcrumb-height Qmd:block hidden"></div>
              <div>
                <Loader type={"bulk_upload"} />
              </div>
            </div>
          </>
        ) : categoryData?.length > GlobalConfiguration?.lengthCheckZero ? (
          <div
            className={`${showInnerSearchBar ? "overflow-hidden" : "overflow-y-scroll scroll-pb-[calc(var(--stepper-moble-height)+var(--padding-md))] Qmd:scroll-pb-top_md scroll-pt-top_md pb-[var(--stepper-moble-height)] Qmd:pb-padding-base"} h-full `}
          >
            <div
              className={`${showInnerSearchBar ? "overflow-y-hidden" : "overflow-y-scroll"} flex-1  relative z-z-index-content`}
            >
              <div className="standard-card-alignment gap-y-gap-md gap-x-gap-sm overflow-y-visible">
                {categoryData.map(
                  ({
                    name,
                    active,
                    custom_category,
                    description,
                    asset_properties,
                    logo_url,
                    id,
                  }) => {
                    return (
                      <CardContainer
                        cardBgColor="primary-card"
                        context={id}
                        onClickHandler={(e, c) => {
                          const isViewAll = location.pathname.includes(
                            `settings/category_dashboard`,
                          );

                          navigate(`view_details/${c}`, {
                            state: { isViewAll },
                          });
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            text={name}
                            textColor="var(--text-primary)"
                            subText="Category name"
                          />

                          <div className="flex gap-x-gap-sm justify-between items-center">
                            <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                              <p
                                className={`text-font-sm flex-1 truncate font-semibold pl-padding-sm ${
                                  active === "Y"
                                    ? "text-settled"
                                    : "text-failed"
                                }`}
                              >
                                {active === "Y" ? "Active" : "Inactive"}
                              </p>

                              <div className="w-full relative flex pl-padding-sm justify-between items-center">
                                <p className="text-font-xs text-text-secondary flex-1 truncate font-normal">
                                  Category status
                                </p>
                              </div>
                            </div>

                            <div className="bg-text-primary flex items-center gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                              {asset_properties?.resource_name ? (
                                <SVGComponent
                                  url={`${custom_category_base_url}/${asset_properties?.resource_name}`}
                                  height={"var(--icon-sm)"}
                                  width={"var(--icon-sm)"}
                                  color={
                                    asset_properties?.colour
                                      ? `var(--${asset_properties?.colour?.replaceAll("_", "-")})`
                                      : "var(--Custom-Category-Blue)"
                                  }
                                  alt={asset_properties?.resource_name}
                                />
                              ) : (
                                <img
                                  className="w-icon-sm h-icon-sm"
                                  src={
                                    logo_url ??
                                    "https://q2pay.in/new_assets/web/beneficiary_category_default.svg"
                                  }
                                  alt="category"
                                />
                              )}
                            </div>
                          </div>
                          <TextWithIcon
                            text={
                              custom_category === "Y" ? "Custom" : "Default"
                            }
                            textColor="var(--text-primary)"
                            subText="Category type"
                          />
                          <TextWithIcon
                            text={description ? description : "Not given"}
                            textColor="var(--text-primary)"
                            subText="Description"
                          />
                        </card-body>
                      </CardContainer>
                    );
                  },
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              className={
                showInnerSearchBar
                  ? `h-height-full  opacity-dark-opacity flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm`
                  : `flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl h-height-full gap-gap-sm ${
                      false ? "h-auto" : ""
                    }`
              }
            >
              <img
                src={
                  "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                }
                alt="No accounts found"
                className={"w-graphic-width-md h-graphic-rectangle-height-md"}
              />
              <p className={"text-font-sm text-text-primary items-center"}>
                No data found.
              </p>
              <div>
                <PrimaryButton
                  isDisabled={showInnerSearchBar}
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={handleClearParams}
                  buttonRef={null}
                  hoverOption="white"
                />
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default CustomCategoryViewAll;
